import type { LeasingFeatureConfig } from '../types/LeasingFeatureConfig';
import { dashboard } from './dashboard/AT';
import { overview } from './overview/AT';
import { productInfoBox } from './productInfoBox/AT';

export const leasing: LeasingFeatureConfig = {
    defaultRoute: 'overview',
    relyOnWebAPIAlias: true,
    dashboard,
    overview,
    productInfoBox,
};
